export default __webpack_public_path__ + "static/media/4.59bfb191.jpg";